import styled from 'styled-components';
import { Box } from '@components/Box';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';

export const HeroWrapper = styled(Box)`
  min-height: 55vw;
`;

export const TextWrapperBox = styled(Box)`
  position: absolute;
  top: 21vw;
  left: 50%;
  transform: translate(-50%, 0px);
  width: fit-content;
  ${themeMediaQuery('below_sm')} {
    top: 40vw;
  }
`;

export const StyledHeroText = styled(Text)`
  text-align: center;
`;

export const DesktopImage = styled(CloudImage)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const MobileImage = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
